<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>Transacciones</ion-title>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/tecservice-transportec/wallet" color="primary"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar>
    <ion-segment mode="md" [(ngModel)]="show">
      <ion-segment-button value="abonos">
        <ion-label>ABONOS</ion-label>
      </ion-segment-button>
      <ion-segment-button value="pagos">
        <ion-label>PAGOS</ion-label>
      </ion-segment-button>
    </ion-segment>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-refresher (ionRefresh)="doRefresh($event)" slot="fixed">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>
  <div class="deposits" *ngIf="show==='abonos'">
    <ion-list *ngIf="!deposits.length && !loading">
      <ion-item lines="none">
        <ion-label>
          <h2>No tienes abonos registrados</h2>
        </ion-label>
      </ion-item>
    </ion-list>
    <ion-list *ngIf="!deposits.length && loading">
      <ion-item lines="none" *ngFor="let deposit of [0,1,2,3,4]">
        <ion-skeleton-text animated style="width: 27px; height: 27px" slot="start"></ion-skeleton-text>
        <ion-row>
          <ion-col>
            <h4>
              <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
            </h4>
            <p class="date">
              <ion-skeleton-text animated style="width: 40%"></ion-skeleton-text>
              <ion-skeleton-text animated style="width: 30%"></ion-skeleton-text>
            </p>
          </ion-col>
        </ion-row>
      </ion-item>
    </ion-list>
    <ion-list>
      <ion-item lines="none" *ngFor="let deposit of deposits">
        <ion-icon name="checkmark-circle-outline" color="success" slot="start" *ngIf="deposit.status"></ion-icon>
        <ion-icon name="time-outline" color="warning" slot="start" *ngIf="!deposit.status"></ion-icon>
        <ion-row>
          <ion-col>
            <h4>
              {{deposit.annotations ? deposit.annotations : deposit.type === 'saldo' ? 'Abono' : 'Suscripción'}} por {{
              deposit.method_name }}
            </h4>
            <p class="date">{{deposit.created_at | date:'dd/MM/yyyy HH:mm'}}</p>
            <ion-button size="small" *ngIf="deposit.reference && !deposit.status" (click)="getDetails(deposit)">
              Ver detalles
            </ion-button>
          </ion-col>
          <ion-col size="auto" [hidden]="!deposit.amount">
            ${{deposit.amount | number}}
            <br />
            <div class="fab-container2">
              <ion-fab-button color="primary" size="small" (click)="goHelp(deposit)">
                <ion-icon src="/assets/icon/help.svg"></ion-icon>
              </ion-fab-button>
              <ion-label>Ayuda</ion-label>
            </div>
          </ion-col>
        </ion-row>
      </ion-item>
    </ion-list>
  </div>

  <div class="payments" *ngIf="show==='pagos'">
    <ion-list *ngIf="!payments.length && !loading">
      <ion-item lines="none">
        <ion-label>
          <h2>No tienes pagos registrados</h2>
        </ion-label>
      </ion-item>
    </ion-list>
    <ion-list *ngIf="!payments.length && loading">
      <ion-item lines="none" *ngFor="let deposit of [0,1,2,3,4]">
        <ion-skeleton-text animated style="width: 27px; height: 27px" slot="start"></ion-skeleton-text>
        <ion-row>
          <ion-col>
            <h4>
              <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
            </h4>
            <p class="date">
              <ion-skeleton-text animated style="width: 40%"></ion-skeleton-text>
              <ion-skeleton-text animated style="width: 30%"></ion-skeleton-text>
            </p>
          </ion-col>
        </ion-row>
      </ion-item>
    </ion-list>
    <ion-list>
      <ion-item
        *ngFor="let payment of payments"
        lines="none"
        (click)="payment.status !== -1 && payment.type !== 'subscription' && goTicket(payment)"
        [class.cancelled]="payment.status === -1"
      >
        <ion-icon src="assets/icon/tickets.svg" color="primary" slot="start"></ion-icon>
        <ion-row>
          <ion-col>
            <h4 *ngIf="payment.method === 'manual'">Cargo manual</h4>
            <h4 *ngIf="payment.method !== 'manual'">
              Compra de {{ payment.type === 'subscription' ? "suscripción" : "boleto" }}
            </h4>
            <p class="date">{{payment.created_at | date:'dd/MM/yyyy HH:mm'}}</p>
          </ion-col>
          <ion-col size="auto" [hidden]="!payment.amount">
            ${{payment.amount | number}}
            <p class="canceled-label" *ngIf="payment.status === -1">CANCELADO</p>
          </ion-col>
        </ion-row>
      </ion-item>
    </ion-list>
  </div>

  <ion-infinite-scroll (ionInfinite)="doInfiniteSales($event)">
    <ion-infinite-scroll-content loadingSpinner="bubbles" loadingText="Cargando..."></ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>
